<template>
  <div class="GenitorSVNascimento">
    <div class="row">
      <div class="col-12">
        <div class="GenitorSVNascimento_header label pb-1 d-flex w-100 justify-content-between align-items-center">
          Genitor {{ propIndexGenitor + 1 }}
          <button class="btn btn-danger btn-sm"
                  @click="removeGenitor()">
            Excluir
          </button>
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-2">
        <div class="form-group">
          <label class="label"
                 :for="`cpf-${propIndexGenitor}`">CPF</label>
          <input :id="`cpf-${propIndexGenitor}`"
                 ref="cpf_genitor"
                 v-model="propGenitor.pessoa.cpf"
                 v-validate="{ regex: /\d{3}\.\d{3}\.\d{3}-\d{2}$/ }"
                 v-mask="{ mask: '999.999.999-99' }"
                 :class="{ 'is-invalid': errors.has('cpf') }"
                 class="form-control form-control-sm"
                 name="cpf"
                 placeholder="000.000.000-00"
                 type="tel"
                 @change="searchCPF">
          <small v-if="errors.has('cpf')"
                 class="invalid-feedback">{{ errors.first('cpf') }}</small>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="label"
                 :for="`nomeGenitor-${propIndexGenitor}`">Nome do genitor<span class="text-danger"> * </span></label>
          <input :id="`nomeGenitor-${propIndexGenitor}`"
                 v-model.lazy="propGenitor.pessoa.nome"
                 v-validate="{ required: true }"
                 v-uppercase
                 :class="{ 'is-invalid': errors.has('nomeGenitor') }"
                 class="form-control form-control-sm text-uppercase"
                 :name="`nomeGenitor-${propIndexGenitor}`"
                 placeholder="Manuelina Terebentina"
                 type="text">
          <small v-if="errors.has(`nomeGenitor-${propIndexGenitor}`)"
                 class="invalid-feedback">{{ errors.first(`nomeGenitor-${propIndexGenitor}`) }}</small>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group">
          <label class="label"
                 for="sexoGenitor">Sexo <span class="text-danger"> * </span></label>
          <select id="sexoGenitor"
                  v-model="propGenitor.pessoa.sexo"
                  v-validate="{ required: true }"
                  :class="{ 'is-invalid': errors.has('sexoGenitor') }"
                  class="custom-select custom-select-sm"
                  name="sexoGenitor">
            <small v-if="errors.has('sexoGenitor')"
                   class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
            <option selected
                    value="">
              Selecione
            </option>
            <option v-for="sex in SEXOS"
                    :key="sex.value"
                    :value="sex.value">
              {{ sex.name }}
            </option>
          </select>

          <small v-if="errors.has('sexoGenitor')"
                 class="invalid-feedback">{{ errors.first('sexoGenitor') }}</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-2">
        <div class="form-group">
          <label class="label"
                 :for="`uf-${propIndexGenitor}`">UF</label>

          <v-select :id="`uf-${propIndexGenitor}`"
                    v-model="propGenitor.pessoa.uf"
                    class="form-control form-control-sm"
                    name="estadoGenitor"
                    :options="selectsOptions.states.map((state)=>state.uf)"
                    @input="ufChanged" />
          <small class="invalid-feedback">{{ errors.first('estadoGenitor') }}</small>
        </div>
      </div>
      <div class="col-sm-5 col-md-4">
        <div class="form-group">
          <label class="label"
                 :for="`naturalidade-${propIndexGenitor}`">Naturalidade </label>
          <v-select :id="`naturalidade-${propIndexGenitor}`"
                    v-model="propGenitor.pessoa.naturalidade"
                    name="naturalidade"
                    class="form-control form-control-sm"
                    placeholder="Selecione"
                    :taggable="propGenitor.pessoa.uf !== 'EX'"
                    :options="citiesFiltered.map((city)=>city.nome)" 
                    @input="changeNaturalidade()" />
        </div>
      </div>
      <div v-if="propGenitor.pessoa.naturalidade == 'Outro'"
           class="col-sm-3 col-md-3">
        <div class="form-group">
          <label class="label"
                 :for="`genitor-${propIndexGenitor}`">Naturalidade Declarada </label>
          <input :id="`genitor-${propIndexGenitor}`"
                 v-model.lazy="propGenitor.pessoa.naturalidade_declarada"
                 class="form-control form-control-sm"
                 name="naturalidade_declarada"
                 placeholder="Cidade declarada"
                 type="text">
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="SegundaViaNascimento_body_header">
          Endereço
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <BoxEndereco :prop-mostrar-exterior="true"
                     :endereco-disable="false"
                     :no-header="true"
                     :data="propGenitor.pessoa.endereco"
                     @onEnderecoAdd="getAddress" />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="SegundaViaNascimento_body_header">
          Ascendentes
        </div>
        <div class="Avo-body">
          <div v-for="(avo, index) in propGenitor.filiacao"
               :key="index">
            <div class="form-group">
              <div class="row">
                <div class="col-12 Avo-title">
                  <label :for="`linha-avos-${index}`"
                         class="label Avo-label">
                    Ascendente - {{ index + 1 }}
                  </label>
                  <hr :id="`linha-avos-${index}`"
                      class="Avo-hr">
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                  <label :for="`nome-avo-${index}`"
                         class="label Avo-label-nome">
                    Nome Completo
                  </label>
                  <input :id="`nome-avo-${index}`"
                         v-model="avo.nome"
                         type="text"
                         class="form-control form-control-sm text-uppercase"
                         :name="`avo-${index}`"
                         @change="changed">
                </div>
                <div class="col-2 d-flex align-items-end">
                  <button class="btn btn-sm btn-outline-danger Avo-btn-eraser-avo"
                          @click="clearAvo(avo, index)">
                    <IconSvg class="Avo-icon-eraser"
                             icon="eraser" />
                    Limpar
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-outline-primary Avo-btn-add-avos mb-4"
                    :disabled="disableButton()"
                    @click="addAvo()">
              <IconSvg class="Avo-icon-add"
                       icon="add" />
              Adicionar mais Ascendentes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import EnderecosService from "@/services/Enderecos"
  import PessoasService from "@/services/Pessoas"

  /* filters */
  import { filterDate, filterMaskedNumber, maskCPF } from '@/filters/filters'

  /* libraries */
  import moment from "moment"

  /* constants */
  import BrazilianStates from "@/constants/brazilianStates"
  import SEXOS from "@/constants/sexos"
  import Cidades from "@/constants/repositorio/cidades"

  /* components */
  import BoxEndereco from '@/components/SofiaRei/BoxEndereco.vue'

  export default {
    name: 'GenitorSVNascimento',
    components: {
      BoxEndereco
    },
    props: { 
      propGenitor: { type: Object, default: () => ({}) },
      propIndexGenitor: { type: Number, default: 0 }
    },
    inject: ['$validator'],
    data () {
      return {
        selectsOptions: {
          states: [...BrazilianStates],
          cities: []
        },
        citiesFiltered: [],
        SEXOS,
        limitDate: moment(new Date()).add(1, 'day').format('YYYY-MM-DD')
      }
    },
    computed: {
      sexo () {
        if (this.propGenitor.pessoa.sexo && this.propGenitor.pessoa.sexo == 'F') return 'nome_feminino'

        return 'nome_masculino'
      }
    },
    mounted () {
      this.getDados()
    },
    methods: {
      changed () {

      },
      getDados () {
        if (this.propGenitor.pessoa.uf) this.ufChanged(this.propGenitor.pessoa.uf)

        if (!this.propGenitor.filiacao || !this.propGenitor.filiacao.length) {
          this.propGenitor.filiacao = [
            {nome: ''},
            {nome: ''}
          ]
        }

        if (this.propGenitor.filiacao.length === 1) {
          this.propGenitor.filiacao.push({nome: ''})
        }

        if (!this.propGenitor.localOcorrenciaFalecimento) {
          this.propGenitor.localOcorrenciaFalecimento = {
            tipo: 'OUTRO',
            endereco: {}
          }
        }

        if (this.propGenitor.pessoa.cpf) this.propGenitor.pessoa.cpf = maskCPF(this.propGenitor.pessoa.cpf)
      },
      async searchCPF () {
        let cpf = filterMaskedNumber(this.propGenitor.pessoa.cpf)

        if (cpf && cpf.length > 10) {
          const dados = await PessoasService.getPessoaByCPF(cpf)

          if (dados.isEmpty) return

          const { nome, datanascimento, sexo, nomemae } = dados
          const sexos = {
            1: 'M',
            2: 'F'
          }

          if (nomemae && (!this.propGenitor.filiacao.length || !this.propGenitor.filiacao[0].nome)) {
            this.propGenitor.filiacao[0].nome = nomemae
          }

          this.propGenitor.pessoa.nome = nome

          let dataNascimento = filterDate(datanascimento)

          this.propGenitor.pessoa.data_nascimento = dataNascimento.split('/').reverse().join('-')

          if ((sexos[sexo] === 'F' || sexos[sexo] === 'M') && (this.propNascimento)) {
            this.propGenitor.pessoa.sexo = sexos[sexo]
          }
        }

        this.propGenitor.pessoa.cpf = this.propGenitor.pessoa.cpf || null
      },
      nascimentoHandler () {
        if (!this.propGenitor.pessoa.data_nascimento) {
          this.propGenitor.pessoa.data_nascimento = null
          this.propGenitor.pessoa.idade = 0
        }
      },
      async ufChanged (uf) {
        if (!uf) {
          this.propGenitor.pessoa.naturalidade = null
          return
        }
        this.citiesFiltered = []

        for (let state of this.selectsOptions.states) {
          if (state.uf == uf) {
            this.propGenitor.pessoa.uf = state.uf
            this.citiesFiltered = Cidades.filter(cidade => cidade.uf == state.uf)

            this.citiesFiltered.push({nome: 'Outro'})

            if (state.uf == 'EX') {
              this.propGenitor.pessoa.naturalidade = 'Outro'
            }

            break
          }
        }
      },
      updateProfissao (profissao = {}) {
        this.propGenitor.pessoa.ocupacao = profissao
        this.propGenitor.pessoa.ocupacao_codigo = profissao.codigo
      },
      changeNacionalidade (nacionalidade) {
        this.propGenitor.pessoa.nacionalidade = nacionalidade
      },
      removeGenitor () {
        this.$emit('removeGenitor')
      },
      clearAvo (avo, index) {
        avo.nome = ''

        if (avo.avo_id) {
          this.$emit('deleteAvo', avo.avo_id)
          this.propGenitor.filiacao[index] = {nome: ''}
        }

        this.propGenitor.filiacao = this.propGenitor.filiacao.filter((avo, index) => {
          return avo.nome || (!avo.nome && index < 2)
        })

        this.changed()
      },
      addAvo () {
        if (this.disableButton()) return

        this.propGenitor.filiacao.push({nome: ''})

        setTimeout(() => {
          const input = document.querySelector(`#nome-avo-${this.propGenitor.filiacao.length - 1}`)

          if (input) input.focus()
        }, 100)
      },
      disableButton () { 
        const semNome = this.propGenitor.filiacao.filter(avo => !avo.nome)

        if (semNome.length) return true

        return false
      },
      getAddress (endereco) {
        this.propGenitor.pessoa.endereco = endereco
        this.changed()
      },
      filterCities (state = null) {
        return state ? this.selectsOptions.cities.filter(city => city.nome === 'Outro' || city.state_id == state.id) : this.selectsOptions.cities
      },
      changeNaturalidade () {
        if (this.propGenitor.pessoa.naturalidade && this.propGenitor.pessoa.naturalidade !== 'Outro') {
          this.propGenitor.pessoa.naturalidade_declarada = null
        }

      }
    }
  }
</script>

<style lang="scss">
  .GenitorSVNascimento {
    &_header {
      border-bottom: 1px solid #858585 ;
    }
  }

  .btn-new-genitor:hover > [class*=icon-add] {
    fill: #fff !important;
  }

  .icon-add {
    fill: #1c7af5 !important;
    width: 16px;
    height: 16px;
    transition: fill 0.2s;
  }

  .Avo {
    &-body {
      margin-top: 20px;
    }

    &-title {
      margin: 0;
    }

    &-hr {
      margin: 0;
      padding: 0;
      background:#696969;
    }

    &-label {
      margin: 0 0 0 0;
      font-size: 16px;
    }

    &-label-nome {
      margin: 1.5px 0 1.5px 0;
      font-size: 16px;
      color: #373a3c
    }

    &-icon-eraser {
      fill: #ff0000;
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }

    &-btn-eraser-avo:hover > [class*=Avo-icon-eraser] {
      fill: #fff;
    }

    &-icon-add {
      fill: #1c7af5;
      width: 20px;
      height: 20px;
      transition: fill 0.2s;
    }

    &-btn-add-avos {
      width: 100%;
    }

    &-btn-add-avos:hover > [class*=Avo-icon-add] {
      fill: #fff;
    }

    &-btn-add-avos:hover:disabled [class*=Avo-icon-add] {
      fill: #1c7af5;
    }
  }
</style>